import React, { Component } from 'react';

const styles = { parallax: { enableBackground: 'new 0 0 800 210' } };
export default class Parallax extends Component {
  componentDidMount() {
    const wh = window.innerHeight;
    const parallaxNodes = document.getElementsByClassName('hero-parallax-image');
    const parallaxContainer = document.getElementsByClassName('hero-parallax')[0];

    this.ParallaxEventListener = window.addEventListener('scroll', function (event) {
      const top = this.pageYOffset;

      if (top < wh * 1.25) {
        parallaxContainer.classList.remove('hero-parallax-hide');
        let layer, speed, yPos;

        for (var i = 0; i < parallaxNodes.length; i++) {
          layer = parallaxNodes[i];
          speed = layer.getAttribute('data-distance');
          yPos = -((top * speed) / 100);
          layer.setAttribute('style', 'transform: translate3d(0px, ' + yPos + 'px, 0px)');
        }
      } else {
        parallaxContainer.classList.add('hero-parallax-hide');
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.ParallaxEventListener);
  }

  render() {
    return (
      <div className="main-section-wrap">
        <div className="hero">
          <h1 className="title_invisible">Honeyguide | To The Mountains</h1>
          <div className="hero-parallax">
            <div className="hero-parallax-image hero-parallax-image-0" data-distance={30} />
            <div className="hero-parallax-image hero-parallax-image-1" data-distance={35} />
            <div
              className="hero-parallax-image hero-parallax-text hero-parallax-text-2"
              data-distance={53}
            />
            <div className="hero-parallax-image hero-parallax-image-2" data-distance={55} />
            <div
              className="hero-parallax-image hero-parallax-text hero-parallax-text-1"
              data-distance={57}
            />
            <div className="hero-parallax-image hero-parallax-image-3" data-distance={65} />
            <div className="hero-parallax-image" data-distance={65}>
              <div className="bottom-section">
                <div className="item-holder">
                  <img src="https://honeyguide.s3.amazonaws.com/assets/icons/medal.png" alt="" />
                  <p>Specialized in <br /> Everest</p>
                </div>
                <div className="item-holder">
                  <img src="https://honeyguide.s3.amazonaws.com/assets/icons/save-money.png" alt="" />
                  <p>Price-match <br /> Guarantee</p>
                </div>
                <div className="item-holder">
                  <img src="https://honeyguide.s3.amazonaws.com/assets/icons/arrows.png" alt="" />
                  <p>Flexible Booking <br /> Options</p>
                </div>
                <div className="item-holder">
                  <img src="https://honeyguide.s3.amazonaws.com/assets/icons/open-24-hours.png" alt="" />
                  <p>24/7 <br /> Ground Support</p>
                </div>
              </div>
            </div>
            <div className="hero-parallax-image" data-distance={65}>
              {/* <a className="btn btn-yellow main-cta" id="homepage-plan-my-trek-btn" onClick={this.props.openModal} >
              Plan your Trek with one Insight a Day
            </a> */}
              <a className="btn btn-yellow main-cta d-none d-md-block" id="homepage-plan-my-trek-btn" href="https://honeyguideapps.com/treks" rel="noopener noreferrer">
                View Treks and Heli Tours in Everest
            </a>
              <a className="btn btn-yellow main-cta d-block d-md-none" id="homepage-plan-my-trek-btn" href="https://honeyguideapps.com/treks" rel="noopener noreferrer">
                View Treks and Heli Tours in Everest
            </a>
            </div>
            <div className="hero-curve">
              <svg
                x="0px"
                y="0px"
                viewBox="0 0 800 206"
                style={styles.parallax}
                xmlSpace="preserve"
              >
                <path
                  className="hero-curve-path"
                  fill="#fff"
                  d="M314.3,181.4L0,0V206.9H800V0L485.7,181.4C432.7,212.1,367.3,212.1,314.3,181.4Z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Landing/Parallax.jsx